import React, { Component } from 'react'
import {
  Form, Button, message, Upload, Select, Icon
} from 'antd'
import { withTranslation } from 'react-i18next';

import { connect } from 'react-redux'

import FlexiblePackageAPI from '@/API/flexiblePackage'
import OperatorAPI from '@/API/operator'
import DeviceAPI from '@/API/device'

import styled from "styled-components"

const TemplateLink = styled(Button)`
  margin-right:20px;
`;

const MyUpload = styled(Upload)`
  .ant-upload-list-item{
    margin-top:24px;
    height:auto;
    background-color:#F8FAFB;
    padding:14px;
    cursor:pointer;
    color:#2FC29B;
    .ant-upload-list-item-name{
      text-decoration:underline;
    }
    .ant-upload-list-item-info{
      background-color:inherit !important;
    }
  }
  .ant-upload-list-item-info .anticon-paper-clip,
  .ant-upload-list-item .anticon-close{
    margin-top:14px;
    margin-right:14px;
  }
`

const Option = Select.Option;

class FlexiblePackage extends Component {
  constructor(props) {

    super(props);
    this.state = {
      operatorList: [],
      productList: [],
      fileList: [],
      form: {
        productName: '',
        operator: ''
      }
    };
  }
  getOperatorCodeList() {
    OperatorAPI.getOperatorCodeList().then(res => {
      this.setState({ operatorList: res })
    })
  }
  getAllProductList() {
    DeviceAPI.getAllProductList().then(res => {
      this.setState({ productList: res })
    })
  }
  componentDidMount() {
    this.getOperatorCodeList()
    this.getAllProductList()
  }
  handleOperatorChange(value) {
    this.setState(prevState => ({
      ...prevState,
      form: {
        operator: value,
        productName: prevState.form.productName
      }
    }))
  }
  handleProductChange(value) {
    this.setState(prevState => ({
      ...prevState,
      form: {
        operator: prevState.form.operator,
        productName: value.join(',')
      }
    }))
  }
  handleSubmit() {
    let formData = new FormData();
    formData.append('operator', this.state.form.operator)
    formData.append('productName', this.state.form.productName)
    formData.append('file', this.state.fileList[0])
    FlexiblePackageAPI.upload(formData).then(res => {
      if (res.code) {
        message.error(res.info)
      } else {
        message.success(res.info)
      }
    })
  }
  render() {
    const { form, operatorList, productList, fileList } = this.state
    const { t } = this.props
    const formItemLayout = {
      labelCol: {
        xs: { span: 6 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 18 },
        sm: { span: 18 },
      },
    }
    const props = {
      name: 'file',
      accept: '.xls,.xlsx,.csv',
      beforeUpload: (file) => {
        this.setState({ fileList: [file] })
        return false
      },
      onPreview(file) {
        var aLink = document.createElement('a')
        var blob = new Blob([file])
        aLink.download = file.name
        aLink.href = URL.createObjectURL(blob)
        aLink.click()
      },
      onRemove: () => {
        this.setState({ fileList: [] })
      }
    }
    return (
      <div style={{ padding: 20 }}>
        <Form {...formItemLayout} style={{ width: 500 }}>
          <Form.Item label={t("IMEI")}>
            <MyUpload {...props} fileList={fileList}>
              <div style={{ marginBottom: '10px' }}>
                <TemplateLink href={'/api/downloadTpl?type=0'} onClick={(e) => { e.stopPropagation() }}>
                  {t('Download Template(.xls)')}
                </TemplateLink>
              </div>

              <Button type="primary">
                <Icon type="upload"></Icon>
                {t('Import IMEI')}
              </Button>
            </MyUpload>

          </Form.Item>
          <Form.Item label={t("Carrier Code")}>
            <Select style={{ width: 240 }} onChange={(value) => { this.handleOperatorChange(value) }}>
              {
                operatorList.map((operator) => (<Option value={operator} key={operator}>{operator}</Option>))
              }
            </Select>
          </Form.Item>
          <Form.Item label={t("Product List")}>
            <Select mode="multiple" style={{ width: 240 }} onChange={(value) => { this.handleProductChange(value) }}>
              {
                productList.map((product) => (<Option value={product} key={product}>{product}</Option>))
              }
            </Select>
          </Form.Item>
          <Form.Item label="">
            <Button style={{ 'margin-left': 125 }} type="primary" onClick={() => { this.handleSubmit() }}>{t('Submit')}</Button>
          </Form.Item>
        </Form>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    roleId: state.roleId,
  }
}

export default connect(mapStateToProps)(withTranslation()(FlexiblePackage));